import { IUserStates } from '../../../models/user.info';
import * as T_T from 'cryface';

export namespace AuthStates {
    export function authStatesFactory() {
        const auth: any = {
            authentication: {
                code: '',
                succeed: false,
                errorCode: '',
                isFetching: false,
                timestamp: new Date()
            },
            userInfo: undefined,
            avatar: null,
            menuList: [],
        };
        return auth;
    }

    export function mutations() {
        return {
            authenticated(state: any, userInfo: any) {
                state.auth.authentication.succeed = true;
                state.auth.authentication.timestamp = new Date();
                if (T_T.simpleDetect(userInfo)) {
                    state.auth.userInfo = userInfo;
                }
            },
            menuListGottem(state: any, menuList: any[]) {
                state.auth.menuList = menuList;
            },
            avatarGotten(state: any, avatar: string) {
                state.auth.avatar = avatar;
            },
            logOut(state: any) {
                state.auth = {
                    authentication: {
                        code: '',
                        succeed: false,
                        errorCode: '',
                        isFetching: false,
                        timestamp: new Date()
                    },
                    userInfo: undefined,
                    avatar: null,
                    menuList: [],
                };
            },
        };
    }
}
